import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { PilotControlledLighting } from '../models/pilot-controlled-lighting.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PilotControlledLightingService } from '../service/pilot-controlled-lighting.service';


@Component({
  selector: 'app-edit-pilot-controlled-lighting',
  templateUrl: './edit-pilot-controlled-lighting.component.html',
  styleUrls: ['./edit-pilot-controlled-lighting.component.scss']
})
export class EditPilotControlledLightingComponent implements OnInit {
  pcl: PilotControlledLighting;
  origPcl: PilotControlledLighting;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedIntensity: string;
  selectedClicks: number;
  selectedSeconds: number;
  PCL: Array<PilotControlledLighting>;

  constructor(private _matDialogRef: MatDialogRef<EditPilotControlledLightingComponent>,
              private _pilotControlledLightingService: PilotControlledLightingService,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data) {
    this.pcl = data.pcl || new PilotControlledLighting();
    this.isNew = data.isNew || false;
    if (this.isNew) {
      this.pcl.clicks = 1;
      this.pcl.intensity = PilotControlledLighting.parseLightingIntensity('high');
      this.pcl.seconds = 1;
    }
    this.airportID = data.airID;
    this.origPcl = Object.assign(new PilotControlledLighting(), data.pcl);
    this.itemsToChange = new Set<number> ();
    this.selectedIntensity = PilotControlledLighting.formatLightingIntensity(this.pcl.intensity).toLowerCase();
    this.selectedClicks = this.pcl.clicks;
    this.selectedSeconds = this.pcl.seconds;
    this.PCL = data.PCL || [];
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      intensity: new FormControl(this.selectedIntensity, [Validators.required]),
      clicks: new FormControl(this.selectedClicks, [Validators.required]),
      seconds: new FormControl(this.selectedSeconds, [Validators.required])
    });
  }

  numOfClicksUnfocus() {
    const CLICKS = this.selectedClicks;
    this.selectedClicks =  (!CLICKS || CLICKS < 1) ? 1 : Math.floor(CLICKS);
  }

  numOfSecondsUnfocus() {
    const SECONDS = this.selectedSeconds;
    this.selectedSeconds =  (!SECONDS || SECONDS < 1) ? 1 : Math.floor(SECONDS);
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.pcl.intensity = PilotControlledLighting.parseLightingIntensity(this.formGroup.get('intensity').value.toLowerCase());
      this.pcl.clicks = this.formGroup.get('clicks').value;
      this.pcl.seconds = this.formGroup.get('seconds').value;
      if (this.isNew) {
        if (this.PCL.filter(element => element.intensity === this.pcl.intensity).length > 0) {
          this._snackBar.open('There is already a lighting entry for this lighting intensity.  ' +
            'If it is incorrect, please go back end edit it.', 'Pilot Activated Lighting', {
            duration: 8000
          });
          return;
        }
        if (this.PCL.filter(element => element.clicks === this.pcl.clicks).length > 0) {
          this._snackBar.open('There is already a lighting entry for this number of clicks.  ' +
            'If it is incorrect, please go back end edit it.', 'Pilot Activated Lighting', {
            duration: 8000
          });
          return;
        }
        res = await this._pilotControlledLightingService.postPCL(this.airportID, this.pcl);
        this.pcl = PilotControlledLighting.parse(res);
      } else {
        res = await this._pilotControlledLightingService.putPCL(this.airportID, this.pcl);
        Object.assign(this.pcl, PilotControlledLighting.parse(res));
        this.pcl = PilotControlledLighting.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, alert: this.pcl});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.pcl, this.origPcl);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
